export default "/images/iphoneX.4bcfe074.jpg";